import React, { useState, useEffect } from 'react';
import styles from './index.module.less';
import {
  Radio,
  Button,
  Row,
  Col,
  Card,
  Empty,
  Tooltip,
  Space,
  Modal,
  Form,
  Select,
  Spin
  //Timeline
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { get_all_users, admin_assign_gifts_action } from '../../../redux/slice';
import FormData from 'form-data';

const { Option } = Select;
//import plus from '../../images/plus.svg';
import SearchBar from '@/common/Content/searchBar';
import CustomTable from 'common/Content/CustomTable';
import {
  //PlusOutlined,
  ArrowLeftOutlined,
  UserAddOutlined
} from '@ant-design/icons';
import { history } from 'app/history';
//import LocalStorage from 'utilities/localStorage';
import AllExportReports from '../reports/AllExportReports';
import auditIcon from '@/assets/images/audit_icon.svg';
import auditGreenIcon from '@/assets/images/audit_green_icon.svg';
//import FormItem from 'common/FormItem';
import moment from 'moment';
//import { Value_of_gift } from '../../../../utilities/helpers';

const filters = [
  /*  {
    name: 'Gift Received',
    value: ''
  },
  {
    name: 'Pending',
    value: 'pending'
  },
  {
    name: 'Accepted',
    value: 'accepted'
  },
  {
    name: 'Rejected',
    value: 'rejected'
  } */
];

function DeactivatedUsersFlowsPage({
  radiofilter,
  setRadiofilter,
  setTriggerFilter,
  page,
  setPage,
  pageSize,
  setPageSize,
  bu_MasterList,
  pagination,
  get_BU_MasterLoading,
  setSearchRequest,
  handleGetInactiveUsers
  // showDisablePopup,
  // setShowDisablePopup,
  // handleDeleteRequest
}) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { get_all_usersLoading, all_users_List, admin_assign_giftsLoading } =
    useSelector((state) => state.admin);
  // Map data to add key field for table
  // const bu_MasterList1 =
  //   bu_MasterList?.map((item) => ({
  //     ...item,
  //     key: item?.id
  //   })) || [];

  // const bu_MasterList1 =
  //   bu_MasterList?.flatMap((item) => {
  //     // If no audit logs → single row
  //     if (!item?.auditLogs || item.auditLogs.length === 0) {
  //       return [
  //         {
  //           ...item,
  //           assignedTo: 'NA',
  //           noOfRequestsAssigned: 0,
  //           key: item.id
  //         }
  //       ];
  //     }

  //     // If audit logs exist → multiple rows
  //     return item.auditLogs.map((log, index) => ({
  //       ...item,
  //       assignedTo: log?.to?.name || 'NA',
  //       noOfRequestsAssigned: log?.requestNums
  //         ? log.requestNums.split(',').length
  //         : 0,
  //       requestNumsAssigned: log?.requestNums || 'NA',
  //       key: `${item.id}-${index}`
  //     }));
  //   }) || [];

  const bu_MasterList1 =
    bu_MasterList?.flatMap((item) => {
      if (!item?.auditLogs || item.auditLogs.length === 0) {
        return [
          {
            ...item,
            assignedTo: 'NA',
            noOfRequestsAssigned: 0,
            assignedToOthers: [],
            key: item.id
          }
        ];
      }

      return item.auditLogs.map((log, index) => ({
        ...item,
        assignedTo: log?.to?.name || 'NA',
        noOfRequestsAssigned: log?.requestNums
          ? log.requestNums.split(',').length
          : 0,
        requestNumsAssigned: log?.requestNums || 'NA',

        assignedToOthers: log?.requestNums ? [log.requestNums] : [],

        key: `${item.id}-${index}`
      }));
    }) || [];

  console.log('bu_MasterList1', bu_MasterList1);
  // const handleBU_record = (record) => {
  //   //console.log('@@@@@@@@@@', record);
  //   //history.push(`edit-bu-master-flow/${record.id}`);
  //   history.push(`create-bu-master-flow/${record.id}?mode=edit`);
  //   LocalStorage.setItem('bu_record', JSON.stringify(record));
  // };
  const [isAllExortModalOpen, setAllExortModalOpen] = useState(false);
  const [hoveredAuditIcon, setHoveredAuditIcon] = useState(null);
  const [isConfigureModalOpen, setIsConfigureModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isAuditLogModalOpen, setIsAuditLogModalOpen] = useState(false);
  const [selectedAuditRecord, setSelectedAuditRecord] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  console.log('selectedAuditRecord', selectedAuditRecord);
  console.log('selectedRecord______', selectedRecord);

  // Fetch users when modal opens
  useEffect(() => {
    if (isConfigureModalOpen) {
      const payload = {
        page: 1,
        per_page: 20,
        search: ''
      };
      dispatch(get_all_users(payload));
      setSearchQuery('');
    }
  }, [isConfigureModalOpen, dispatch]);

  // Debounced search effect
  useEffect(() => {
    if (!isConfigureModalOpen) return;

    const timeoutId = setTimeout(() => {
      const payload = {
        page: 1,
        per_page: 20,
        search: searchQuery || ''
      };
      dispatch(get_all_users(payload));
    }, 300); // 300ms debounce

    return () => clearTimeout(timeoutId);
  }, [searchQuery, isConfigureModalOpen, dispatch]);

  const handleConfigureModalOpen = (record) => {
    console.log('record______', record);
    setSelectedRecord(record);
    setIsConfigureModalOpen(true);
  };

  const handleConfigureModalClose = () => {
    setIsConfigureModalOpen(false);
    setSelectedRecord(null);
    form.resetFields();
  };

  const handleConfigureSubmit = () => {
    form.validateFields().then((values) => {
      const formdata = new FormData();
      formdata.append('fromId', selectedRecord?.id);
      formdata.append('toId', values.userId);

      dispatch(admin_assign_gifts_action(formdata)).then(function (response) {
        if (response?.payload?.success) {
          handleConfigureModalClose();
          handleGetInactiveUsers();
        }
      });
    });
  };

  const getRowSpanProps = (record, index) => {
    const auditCount = record?.auditLogs?.length || 1;
    const firstIndex = bu_MasterList1.findIndex(
      (item) => item.id === record.id
    );
    return {
      isFirstRow: index === firstIndex,
      rowSpan: index === firstIndex ? auditCount : 0
    };
  };

  const columns = [
    // {
    //   title: 'Employee Name',
    //   dataIndex: 'name',
    //   key: 'name',
    //   ellipsis: {
    //     showTitle: false
    //   },
    //   width: '20%',
    //   sorter: (a, b) => a?.name?.localeCompare(b?.name),
    //   render: (name, record) => {
    //     const fullName = `${record?.name || ''}`.trim();
    //     return (
    //       <>
    //         <Tooltip
    //           title={fullName}
    //           color={'white'}
    //           overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
    //           arrowPointAtCenter="false"
    //         >
    //           {/* <a href={`view-gift-received-details/${record.id}`}> */}
    //           <span className={styles.text_transform}>{fullName || ''}</span>
    //           {/*  </a> */}
    //         </Tooltip>
    //       </>
    //     );
    //   }
    // },
    {
      title: 'Employee Name',
      dataIndex: 'name',
      key: 'name',
      width: '20%',
      render: (text, record, index) => {
        const auditCount = record?.auditLogs?.length || 1;

        // find first index of this employee in table
        const firstIndex = bu_MasterList1.findIndex(
          (item) => item.id === record.id
        );

        const isFirstRow = index === firstIndex;

        return {
          children: (
            <Tooltip title={text}>
              <span className={styles.text_transform}>{text}</span>
            </Tooltip>
          ),
          props: {
            rowSpan: isFirstRow ? auditCount : 0
          }
        };
      }
    },

    // {
    //   title: 'No. of Pending Request',
    //   key: 'pending',
    //   width: '15%',
    //   dataIndex: 'pendingReqs',
    //   sorter: (a, b) =>
    //     (a?.pendingReqs?.length || 0) - (b?.pendingReqs?.length || 0),
    //   render: (pendingReqs) => {
    //     const count = pendingReqs?.length || 0;
    //     return (
    //       <>
    //         <Tooltip
    //           title={count}
    //           color={'white'}
    //           overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
    //           arrowPointAtCenter="false"
    //         >
    //           <span>{count}</span>
    //         </Tooltip>
    //       </>
    //     );
    //   }
    // },

    {
      title: 'No. of Pending Request',
      key: 'pending',
      width: '20%',
      dataIndex: 'pendingReqs',
      render: (pendingReqs, record, index) => {
        const count = pendingReqs?.length || 0;
        const { rowSpan } = getRowSpanProps(record, index);

        return {
          children: (
            <Tooltip
              title={count}
              color="white"
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
            >
              <span>{count}</span>
            </Tooltip>
          ),
          props: {
            rowSpan
          }
        };
      }
    },

    // {
    //   title: 'Request #',
    //   key: 'requestNumber',
    //   dataIndex: 'pendingReqs',
    //   ellipsis: {
    //     showTitle: false
    //   },
    //   width: '25%',
    //   render: (pendingReqs) => {
    //     const tickets =
    //       pendingReqs
    //         ?.map((item) => item)
    //         .filter((item) => item)
    //         .join(', ') || 'NA';
    //     return (
    //       <>
    //         <Tooltip
    //           title={tickets}
    //           color={'white'}
    //           overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
    //           arrowPointAtCenter="false"
    //           placement="top"
    //         >
    //           <span className={styles.text_transform_ellipsis}>{tickets}</span>
    //         </Tooltip>
    //       </>
    //     );
    //   }
    // },

    {
      title: 'Request #',
      key: 'requestNumber',
      dataIndex: 'pendingReqs',
      width: '15%',
      render: (pendingReqs, record, index) => {
        const tickets = pendingReqs?.filter(Boolean).join(', ') || 'NA';

        const { rowSpan } = getRowSpanProps(record, index);

        return {
          children: (
            <Tooltip
              title={tickets}
              color="white"
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              placement="top"
            >
              <span className={styles.text_transform_ellipsis}>{tickets}</span>
            </Tooltip>
          ),
          props: {
            rowSpan
          }
        };
      }
    },

    {
      title: 'Assigned To',
      dataIndex: 'assignedTo',
      key: 'assignedTo',
      width: '20%',
      ellipsis: {
        showTitle: false
      },
      render: (assignedTo) => (
        <Tooltip
          title={assignedTo}
          color="white"
          overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
        >
          <span className={styles.text_transform_ellipsis}>
            {assignedTo || 'NA'}
          </span>
        </Tooltip>
      )
    },
    {
      title: 'No of Request Assigned',
      dataIndex: 'noOfRequestsAssigned',
      key: 'noOfRequestsAssigned',
      width: '25%',
      sorter: (a, b) =>
        (a?.noOfRequestsAssigned || 0) - (b?.noOfRequestsAssigned || 0),
      // render: (count, record) => (
      //   <Tooltip
      //     title={record?.requestNumsAssigned}
      //     color="white"
      //     overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
      //   >
      //     <span>{count || 0}</span>
      //   </Tooltip>
      // )
      render: (count) => (
        // <Tooltip
        //   title={record?.requestNumsAssigned}
        //   color="white"
        //   overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
        // >
        <span>{count || 0}</span>
        // </Tooltip>
      )
    },

    // {
    //   title: 'Assigned to others',
    //   key: 'assignedToOthers',
    //   dataIndex: 'assignedReqs',
    //   ellipsis: {
    //     showTitle: false
    //   },
    //   width: '25%',
    //   render: (assignedReqs) => {
    //     const tickets =
    //       assignedReqs
    //         ?.map((item) => item)
    //         .filter((item) => item)
    //         .join(', ') || 'NA';
    //     return (
    //       <>
    //         <Tooltip
    //           title={tickets}
    //           color={'white'}
    //           overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
    //           arrowPointAtCenter="false"
    //           placement="top"
    //         >
    //           <span className={styles.text_transform_ellipsis}>{tickets}</span>
    //         </Tooltip>
    //       </>
    //     );
    //   }
    // },

    {
      title: 'Assigned to others',
      key: 'assignedToOthers',
      dataIndex: 'assignedToOthers',
      width: '25%',
      render: (assignedToOthers) => {
        const tickets = assignedToOthers?.filter(Boolean).join(', ') || 'NA';

        return (
          <Tooltip
            title={tickets}
            color="white"
            overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
            placement="top"
          >
            <span className={styles.text_transform_ellipsis}>{tickets}</span>
          </Tooltip>
        );
      }
    },

    {
      title: 'Action',
      key: 'action',
      width: '20%',
      render: (record, _, index) => {
        const uniqueId = record?.id || record?.email || record?.key || index;
        console.log('record______pendingReqs:', record?.pendingReqs?.length);
        return (
          <>
            <Space size="middle">
              <UserAddOutlined
                className={`${styles.edit_bu}`}
                style={{
                  cursor:
                    !record?.pendingReqs || record?.pendingReqs?.length === 0
                      ? 'not-allowed'
                      : 'pointer',
                  fontSize: '14px',
                  opacity:
                    !record?.pendingReqs || record?.pendingReqs?.length === 0
                      ? 0.5
                      : 1
                }}
                onClick={() => {
                  if (record?.pendingReqs && record?.pendingReqs?.length > 0) {
                    handleConfigureModalOpen(record);
                  }
                }}
              />
              <img
                src={hoveredAuditIcon === uniqueId ? auditGreenIcon : auditIcon}
                alt="Audit"
                className={`${styles.edit_bu}`}
                style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                onMouseEnter={() => setHoveredAuditIcon(uniqueId)}
                onMouseLeave={() => setHoveredAuditIcon(null)}
                onClick={() => {
                  setSelectedAuditRecord(record);
                  setIsAuditLogModalOpen(true);
                }}
              />
            </Space>
          </>
        );
      }
    }
  ];

  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        {/*  <Image alt="users_empty_state" src={emptyState} preview={false} /> */}
        <div className={styles.empty_state_text}>
          There are no deactivated users to display
        </div>
      </span>
    )
  };

  return (
    <>
      <div className={`${styles.container}`}>
        <Row className={`${styles.row_container}`}>
          <div className={`${styles.gift_container}`}>
            <div className={`${styles.myGift_title}`}>
              Configure deactivated users
            </div>
            <div className={`${styles.myGift_text}`}>
              View and manage deactivated users
            </div>
          </div>
          <div className={`${styles.declareGift_div}`}>
            <Row>
              {/* <Button
                className={`${styles.export_button}`}
                onClick={() => setAllExortModalOpen(true)}
              >
                Export
              </Button>
              <Button
                className={`${styles.declareGift_button}`}
                icon={<PlusOutlined />}
                onClick={() => history.push('/create-bu-master-flow')}
              >
                Add New Deactivated User
              </Button> */}
              <Button
                style={{ marginLeft: '20px' }}
                className={`${styles.declareGift_button}`}
                icon={<ArrowLeftOutlined />}
                onClick={() => history.push('/admin')}
              >
                Back
              </Button>
            </Row>
          </div>
        </Row>
        <div className={`${styles.tabs_container}`}>
          <Row>
            {/* className={`${styles.row_container}`} */}
            <Col span={16}>
              <Radio.Group
                value={radiofilter}
                size="small"
                className={`${styles.button_import_style}`}
              >
                {filters.map((item, index) => {
                  return (
                    <Radio.Button
                      value={item.value}
                      key={index}
                      //className={`${styles.RadioButton_import_style}`}
                      onChange={() => {
                        window.localStorage.setItem(
                          'set_Radiofilter',
                          JSON?.stringify(item.value)
                        );
                        setRadiofilter(item.value);
                        setTriggerFilter(true);
                      }}
                    >
                      {item.name}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Col>
            <Col span={8}>
              <SearchBar
                onChange={(e) => {
                  setSearchRequest(e.target.value);
                  setTriggerFilter(true);
                }}
                className={` ${styles.searchbar}`}
                inputProps={{
                  placeholder: 'Search by deactivated user name'
                }}
              />
            </Col>
          </Row>
        </div>
        <Card className={`${styles.cardStyles}`}>
          <div className={`${styles.table_container}`}>
            <CustomTable
              showSorterTooltip={false}
              columns={columns}
              dataSource={bu_MasterList1}
              locale={locale}
              loading={get_BU_MasterLoading}
              pagination={{
                current: page,
                pageSize: pageSize,
                showSizeChanger: true,
                size: 'small',
                total: pagination?.total_records || 0,
                onChange: (page, pageSize) => {
                  setPage(page);
                  setPageSize(pageSize);
                }
              }}
            />
          </div>
        </Card>
        {isAllExortModalOpen ? (
          <AllExportReports
            isAllExortModalOpen={isAllExortModalOpen}
            setAllExortModalOpen={setAllExortModalOpen}
            apiName={'bu_and_sbgs_master'}
          />
        ) : (
          ''
        )}
      </div>

      {/* Configure Deactivated Users Modal */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: '#E0F2FE',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <UserAddOutlined style={{ fontSize: '20px', color: '#2264AE' }} />
            </div>
            {/*  <span
              style={{ fontWeight: 600, fontSize: '18px', color: '#101828' }}
            >
              Configure Deactivated Users
            </span> */}
          </div>
        }
        open={isConfigureModalOpen}
        onCancel={handleConfigureModalClose}
        footer={false}
        width={520}
        className={styles.configure_modal}
      >
        <Spin spinning={get_all_usersLoading}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleConfigureSubmit}
            className={styles.configure_form}
          >
            <Form.Item
              label={
                <span
                  style={{
                    color: '#101828',
                    fontSize: '14px',
                    fontWeight: 500
                  }}
                >
                  Configure Deactivated Users
                </span>
              }
              name="userId"
              rules={[
                {
                  required: true,
                  message: 'Please select a user'
                }
              ]}
            >
              <Select
                placeholder="Select user"
                showSearch
                onSearch={(value) => {
                  setSearchQuery(value);
                }}
                filterOption={false}
                style={{ width: '100%' }}
                notFoundContent={
                  get_all_usersLoading ? (
                    <Spin size="small" />
                  ) : (
                    'No users found'
                  )
                }
              >
                {all_users_List?.map((user) => (
                  <Option key={user?.id} value={user?.id}>
                    {user?.givenName} {user?.surname} ({user?.email})
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item style={{ marginBottom: 0, marginTop: '24px' }}>
              <Space
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '12px'
                }}
              >
                <Button
                  onClick={handleConfigureModalClose}
                  style={{
                    border: '1px solid #D0D5DD',
                    color: '#344054',
                    fontWeight: 600
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={admin_assign_giftsLoading}
                  style={{
                    background: '#2264AE',
                    borderColor: '#2264AE',
                    fontWeight: 600
                  }}
                >
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Spin>
      </Modal>

      {/* Audit Log Modal */}
      <Modal
        title={<span className={styles.audit_log_title}>Audit log</span>}
        open={isAuditLogModalOpen}
        onCancel={() => {
          setIsAuditLogModalOpen(false);
          setSelectedAuditRecord(null);
        }}
        footer={false}
        width={800}
        className={styles.audit_log_modal}
        closeIcon={<span className={styles.audit_log_close_icon}>×</span>}
      >
        <div className={styles.audit_log_content}>
          {selectedAuditRecord?.auditLogs &&
          selectedAuditRecord.auditLogs.length > 0 ? (
            <div className={styles.audit_log_table}>
              <div className={styles.audit_log_table_body}>
                {/* Continuous vertical timeline lines */}
                {selectedAuditRecord.auditLogs.length > 0 && (
                  <>
                    <div className={styles.audit_log_timeline_line} />
                    <div
                      className={`${styles.audit_log_timeline_line} ${styles.audit_log_timeline_line_second}`}
                    />
                  </>
                )}
                {selectedAuditRecord.auditLogs.map((log, index) => (
                  <React.Fragment key={index}>
                    <div
                      className={`${styles.audit_log_table_row} ${
                        index === 0 ? styles.audit_log_table_row_first : ''
                      }`}
                    >
                      {/* Old Approver Column */}
                      <div className={styles.audit_log_table_col}>
                        {log?.from ? (
                          <>
                            <div className={styles.audit_log_name}>
                              {log.from.name || 'N/A'}
                            </div>
                            <div className={styles.audit_log_role}>
                              Old Approver
                            </div>
                            <div className={styles.audit_log_date}>
                              {log.from.leftOn
                                ? moment(log.from.leftOn).format('MMM DD, YYYY')
                                : 'N/A'}
                            </div>
                            <div className={styles.audit_log_time}>
                              {log.from.leftOn
                                ? moment(log.from.leftOn).format('HH:mm:ss')
                                : 'N/A'}
                            </div>
                          </>
                        ) : (
                          <div className={styles.audit_log_empty_cell}>-</div>
                        )}
                      </div>

                      {/* Timeline wrapper with dot */}
                      <div
                        className={`${styles.audit_log_timeline_wrapper} ${
                          index === 0 ? styles.audit_log_timeline_first : ''
                        } ${
                          index === selectedAuditRecord.auditLogs.length - 1
                            ? styles.audit_log_timeline_last
                            : ''
                        }`}
                      >
                        <div className={styles.audit_log_timeline_dot} />
                      </div>

                      {/* New Approver Column */}
                      <div className={styles.audit_log_table_col}>
                        {log?.to ? (
                          <>
                            <div className={styles.audit_log_name}>
                              {log.to.name || 'N/A'}
                            </div>
                            <div className={styles.audit_log_role}>
                              New Approver
                            </div>
                            <div className={styles.audit_log_date}>
                              {log.to.assignedOn
                                ? moment(log.to.assignedOn).format(
                                    'MMM DD, YYYY'
                                  )
                                : 'N/A'}
                            </div>
                            <div className={styles.audit_log_time}>
                              {log.to.assignedOn
                                ? moment(log.to.assignedOn).format('HH:mm:ss')
                                : 'N/A'}
                            </div>
                          </>
                        ) : (
                          <div className={styles.audit_log_empty_cell}>-</div>
                        )}
                      </div>

                      {/* Timeline wrapper with dot between New Approver and Request Numbers */}
                      <div
                        className={`${styles.audit_log_timeline_wrapper} ${
                          index === 0 ? styles.audit_log_timeline_first : ''
                        } ${
                          index === selectedAuditRecord.auditLogs.length - 1
                            ? styles.audit_log_timeline_last
                            : ''
                        }`}
                      >
                        <div className={styles.audit_log_timeline_dot} />
                      </div>

                      {/* Request Numbers Column */}
                      <div className={styles.audit_log_table_col}>
                        <div className={styles.audit_log_request_header}>
                          Request No.s
                        </div>
                        <div className={styles.audit_log_request_nums}>
                          {log?.requestNums && log.requestNums.trim() !== ''
                            ? log.requestNums
                            : 'NA'}
                        </div>
                      </div>
                    </div>
                    {index < selectedAuditRecord.auditLogs.length - 1 && (
                      <div className={styles.audit_log_divider} />
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          ) : (
            <div className={styles.audit_log_empty}>
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No audit logs available"
              />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}
export default DeactivatedUsersFlowsPage;
